import script from "./FlatOvalDimensionInputs.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlatOvalDimensionInputs.vue?vue&type=script&setup=true&lang=ts"

import "./FlatOvalDimensionInputs.vue?vue&type=style&index=0&id=2368c12a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2368c12a"]])

export default __exports__